<template>
  <div>
    <b-card-code name="main">
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent="handleSubmit">
          <b-row>
            <b-col md="6">
              <b-form-group label="Module Name" label-for="name">
                <label style="color: red !important">*</label>
                <validation-provider
                  #default="{ errors }"
                  rules="required"
                  name="Module Name"
                >
                  <b-form-input
                    id="name"
                    v-model="form.name"
                    placeholder="Enter Module Name"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Software" label-for="sid">
                <label style="color: red !important">*</label>
                <validation-provider
                  #default="{ errors }"
                  rules="required"
                  name="Software"
                >
                  <v-select
                    v-model="selectedSoftware"
                    label="name"
                    placeholder="Select Software"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="softwareOptions"
                    @input="handleSoftwareChange"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Parent Module" label-for="parent">
                <v-select
                  v-model="selectedParent"
                  label="name"
                  placeholder="Select Parent Module (optional)"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="filteredModuleOptions"
                  @input="handleParentChange"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Icon" label-for="icon">
                <b-form-input
                  id="icon"
                  v-model="form.icon"
                  placeholder="Enter Icon Name (optional)"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="URL" label-for="url">
                <b-form-input
                  id="url"
                  v-model="form.url"
                  placeholder="Enter Module URL (optional)"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Sort Order" label-for="sort">
                <b-form-input
                  id="sort"
                  v-model.number="form.sort"
                  type="number"
                  placeholder="Enter Sort Order"
                />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group label="Routes">
                <div
                  v-for="(route, index) in form.routes"
                  :key="index"
                  class="route-item mb-2"
                >
                <!-- <div class="row"> -->
                  <b-input-group>
                    <b-form-input
                      v-model="route.route"
                      :placeholder="`Route ${index + 1}`"
                    />
                    <b-input-group-append>
                      <b-button
                        variant="danger"
                        size="sm"
                        @click="removeRoute(index)"
                        :disabled="form.routes.length === 1"
                      >
                        <feather-icon icon="XIcon" size="14" />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </div>
                <b-button
                  variant="secondary"
                  size="sm"
                  @click="addRoute"
                  class="mt-2"
                >
                  <feather-icon icon="PlusIcon" class="mr-50" size="14" />
                  Add Route
                </b-button>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Installed" label-for="installed">
                <b-form-checkbox
                  v-model="form.installed"
                  class="custom-control-primary"
                  name="installed"
                  switch
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-alert
            v-if="error"
            show
            variant="danger"
            dismissible
            @dismissed="error = ''"
            class="mt-2"
          >
            {{ error }}
          </b-alert>

          <b-alert
            v-if="success"
            show
            variant="success"
            dismissible
            @dismissed="success = ''"
            class="mt-2"
          >
            {{ success }}
          </b-alert>

          <div class="mt-3">
            <b-button
              type="submit"
              variant="primary"
              :disabled="loading"
              class="mr-1"
            >
              {{ isEditMode ? 'Update' : 'Create' }} Module
            </b-button>
            <b-button
              variant="secondary"
              @click="$router.push('/setup/modules')"
              :disabled="loading"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </b-card-code>
  </div>
</template>
<script>
import { moduleService } from '@/services/moduleService'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BInputGroup,
  BInputGroupAppend,
  BAlert,
  BFormCheckbox
} from 'bootstrap-vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import BCardCode from '@core/components/b-card-code'
import vSelect from 'vue-select'
import axios from '@/components/axios'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    BAlert,
    BFormCheckbox,
    FeatherIcon,
    BCardCode,
    vSelect
  },
  data () {
    return {
      isEditMode: false,
      loading: false,
      error: '',
      success: '',
      accessToken: localStorage.getItem('accessToken'),
      baseApi: process.env.VUE_APP_APIENDPOINT,
      softwareOptions: [],
      moduleOptions: [],
      selectedSoftware: null,
      selectedParent: null,
      form: {
        name: '',
        sid: null,
        parent: null,
        icon: '',
        url: '',
        installed: true,
        sort: 1,
        routes: [{ route: '' }]
      }
    }
  },
  computed: {
    // Filter out current module from parent options when editing
    filteredModuleOptions () {
      if (this.isEditMode && this.$route.params.id) {
        const currentId = parseInt(this.$route.params.id)
        return this.moduleOptions.filter((module) => module.id !== currentId)
      }
      return this.moduleOptions
    }
  },
  async mounted () {
    const role = JSON.parse(localStorage.getItem('userData')).role
    if (role !== 'admin') {
      this.$router.push('/')
    }
    // Load dropdowns first
    await Promise.all([this.getSoftwares(), this.getModules()])
    if (this.$route.params.id) {
      this.isEditMode = true
      this.loadModule(this.$route.params.id)
    }
  },
  methods: {
    // Fetch software options
    async getSoftwares () {
      try {
        const requestOptions = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.accessToken}`
          },
          url: `${this.baseApi}/getsoftwares`
        }
        await axios(requestOptions)
          .then((response) => {
            this.softwareOptions = response.data.data.data ? response.data.data.data : response.data.data
          })
          .catch((error) => {
            console.log(error, 'error')
            this.error = 'Failed to load software options'
          })
      } catch (error) {
        console.log(error, 'error')
      }
    },

    // Fetch module options
    async getModules () {
      try {
        const requestOptions = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.accessToken}`
          },
          url: `${this.baseApi}/getmodules`
        }
        await axios(requestOptions)
          .then((response) => {
            this.moduleOptions = response.data.data.data ? response.data.data.data : response.data.data
          })
          .catch((error) => {
            console.log(error, 'error')
            this.error = 'Failed to load module options'
          })
      } catch (error) {
        console.log(error, 'error')
      }
    },

    // Handle software selection change
    handleSoftwareChange (selected) {
      if (selected) {
        this.form.sid = selected.id
        this.selectedSoftware = selected
      } else {
        this.form.sid = null
        this.selectedSoftware = null
      }
    },

    // Handle parent module selection change
    handleParentChange (selected) {
      if (selected) {
        this.form.parent = selected.id
        this.selectedParent = selected
      } else {
        this.form.parent = null
        this.selectedParent = null
      }
    },

    // Add new route field
    addRoute () {
      this.form.routes.push({ route: '' })
    },

    // Remove route field
    removeRoute (index) {
      if (this.form.routes.length > 1) {
        this.form.routes.splice(index, 1)
      }
    },

    // Load module data for editing
    async loadModule (id) {
      try {
        this.loading = true
        this.error = ''
        const response = await moduleService.getModuleById(id)
        if (response.data && response.data.length > 0) {
          const module = response.data[0]
          this.form.name = module.name || ''
          this.form.sid = module.sid || null
          this.form.parent = module.parent || null
          this.form.icon = module.icon || ''
          this.form.url = module.url || ''
          this.form.installed = module.installed === 1 || module.installed === true
          this.form.sort = module.sort || 1

          // Set selected software from options
          if (this.form.sid && this.softwareOptions.length > 0) {
            const software = this.softwareOptions.find((s) => s.id === this.form.sid)
            if (software) {
              this.selectedSoftware = software
            }
          }

          // Set selected parent from options (exclude current module)
          if (this.form.parent && this.moduleOptions.length > 0) {
            const parent = this.moduleOptions.find((m) => m.id === this.form.parent && m.id !== parseInt(id))
            if (parent) {
              this.selectedParent = parent
            }
          }

          // Load routes
          if (module.routes && module.routes.length > 0) {
            this.form.routes = module.routes.map((r) => ({
              route: r.route || ''
            }))
          } else {
            this.form.routes = [{ route: '' }]
          }
        }
      } catch (err) {
        this.error = err.message || 'Failed to load module'
      } finally {
        this.loading = false
      }
    },

    // Handle form submission
    async handleSubmit () {
      try {
        const isValid = await this.$refs.simpleRules.validate()
        if (!isValid) {
          return
        }

        this.loading = true
        this.error = ''
        this.success = ''

        // Filter out empty routes
        const routes = this.form.routes
          .filter((r) => r.route && r.route.trim() !== '')
          .map((r) => ({ route: r.route.trim() }))

        const payload = {
          ...this.form,
          installed: this.form.installed ? 1 : 0,
          routes
        }

        if (this.isEditMode) {
          const moduleId = this.$route.params.id
          await moduleService.updateModule(moduleId, payload)
          this.success = 'Module updated successfully!'
        } else {
          await moduleService.createModule(payload)
          this.success = 'Module created successfully!'
        }

        // Redirect after success
        setTimeout(() => {
          this.$router.push('/setup/modules')
        }, 1500)
      } catch (err) {
        this.error = err.message || 'An error occurred'
        if (err.errors) {
          const errorMessages = Object.values(err.errors).flat()
          this.error = errorMessages.join(', ')
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
